import { t } from 'i18next'

import closeIcon from '../../static/icons/close.svg'
import searchIcon from '../../static/icons/magnifier.svg'

import type { TableFiltersProps } from './TableFilters.types'

function TableFilters(params: TableFiltersProps) {
  const { search, setSearch } = params

  const clearSearch = () => {
    setSearch('')
  }

  return (
    <div className="mb-4 max-w-xs flex items-center space-x-4">
      <div className="flex items-center border border-gray-400 rounded-md px-2 py-1">
        <img
          src={searchIcon}
          alt=""
          className="w-4 h-4 mr-1"
          style={{ filter: 'invert(0.5)' }}
        />

        <input
          type="text"
          placeholder={t('Tenants.Filter.Search')}
          className="w-full outline-none p-1 text-sm"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        {search && (
          <button onClick={clearSearch}>
            <img src={closeIcon} alt="" className="w-4 h-4 ml-1" />
          </button>
        )}
      </div>
    </div>
  )
}

export default TableFilters
